export default {
  DRIVER: 'DRIVER',
  NODE: 'NODE',
  POOL: 'POOL',
};
